import { Component, OnInit } from '@angular/core';
import { SnotifyService } from 'ng-snotify';
import { Config } from '../config/config';
import { RestDataService } from '../service/rest-data.service';
import { SharedDataService } from '../service/shared-data.service';

@Component({
  selector: 'app-my-dashboard',
  templateUrl: './my-dashboard.component.html',
  styleUrls: ['./my-dashboard.component.scss']
})
export class MyDashboardComponent implements OnInit {
  placeholder: string;
  searchFocus = false;
  str: string;
  listData = [];
  suggestedTopicList = [];
  filteredSuggestion: any[];
  constructor(
    private config: Config,
    private sharedService: SharedDataService,
    private restService: RestDataService,
    private snotify: SnotifyService,
  ) { }

  ngOnInit() {
    this.placeholder ="Search Topic";
    this.fetchSubribedTopic();
    this.fetchSuggestedTopic();
  }

  fetchSubribedTopic() {
    this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/subscriber/topics').subscribe(res=>{
      this.listData  = res.topics;
    })
  }

  fetchSuggestedTopic() {
    this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/trending/topics').subscribe(res=>{
      this.suggestedTopicList = [];
      res.topics.forEach(e=>{
        if(!this.listData.includes(e)){
          this.suggestedTopicList.push(e)
        }
      })
    })
  }

  filterData(event, listingInput) {
    console.log(event.target.value, listingInput)
    if(event.target.value.length > 1) {
      const url = this.config.get('product').baseUrl
      + '/api/cms/story/editor/topics?page=0&size=100&sort=lastModifiedDate,desc&fields=alias&'
      + 'search=alias~'+event.target.value.toLowerCase()+',pageType:TOPIC,status:PUBLISHED,pageType!EXTERNAL';
      this.restService.http_get(url).subscribe(
      data => {
        this.filteredSuggestion = [];
        this.filteredSuggestion = data;
        if(this.filteredSuggestion.length === 0) {
          this.filteredSuggestion.push(this.str)
        }
      }
    )
    } else {
      this.filteredSuggestion = [];
    }
  }

  selectAutoComplete(item){
    if(!this.listData.includes(item)){
      this.restService.http_put(this.config.get('product').baseUrl
      + '/api/cms/subscriber/topics?topic='+item, '',
        (result) => {
          this.fetchSubribedTopic();
        });
      this.filteredSuggestion = [];
      this.str = ''
    } else {
      this.snotify.info('\"' + item + '\" topic already subscribed', '', this.sharedService.getConfig(false));
    }
  }

  removeTopic(index, data) {
    this.listData.splice(index,1);
    this.restService.http_delete(this.config.get('product').baseUrl
    + '/api/cms/subscriber/topics?topic='+data, '',
      (result) => {
        this.fetchSubribedTopic();
        this.fetchSuggestedTopic();
      });
  }

  addTopic(data, index){
     this.suggestedTopicList.splice(index, 1);
     this.restService.http_put(this.config.get('product').baseUrl
      + '/api/cms/subscriber/topics?topic='+data, '',
        (result) => {
          this.fetchSubribedTopic();
        });
  }
}